import type * as vscode from './@types/vscode';

export function getDownloadCallback(vscode: typeof import('./@types/vscode')) {
    return (dataOrUri: Uint8Array | vscode.URI, name: string) => {
        // If the data is provided as Buffer, we create a
        // blob URL out of it to produce a valid link
        let url: string;
        if (vscode.URI.isUri(dataOrUri)) {
            url = dataOrUri.toString(true);
        } else {
            const blob = new Blob([dataOrUri]);
            url = URL.createObjectURL(blob);

            // Ensure to free the data from DOM eventually
            setTimeout(() => URL.revokeObjectURL(url));
        }

        // In order to download from the browser, the only way seems
        // to be creating a <a> element with download attribute that
        // points to the file to download.
        // See also https://developers.google.com/web/updates/2011/08/Downloading-resources-in-HTML5-a-download
        const anchor = document.createElement('a');
        window.document.body.appendChild(anchor);
        anchor.download = name;
        anchor.href = url;
        anchor.click();

        // Ensure to remove the element from DOM eventually
        setTimeout(() => anchor.remove());
    };
}
